import { createContext, useContext } from 'react'

export const SaleShellContext = createContext(false)

export const useSaleShell = (): boolean => useContext(SaleShellContext)
